import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useFlag } from '@/package';
import { useTaskFrameStore } from '@/store';

import { LoadingIndicator } from '../LoadingIndicator';

const ToolInitializeLoading = () => {
  const { t } = useTranslation();
  const { isFrameFileLoading } = useTaskFrameStore();
  const { value: isInitialized, setTrue: completeInitialized } = useFlag(false);

  useEffect(() => {
    if (isInitialized) return;

    if (!isFrameFileLoading) completeInitialized();
  }, [isInitialized, isFrameFileLoading]);

  return !isInitialized ? (
    <LoadingIndicator message={t('common.loading.cancerophobia')} />
  ) : (
    <></>
  );
};

ToolInitializeLoading.displayName = 'ToolInitializeLoading';

export default ToolInitializeLoading;
